import React from "react";
import Hero from "../../components/Hero";
import HeroImage from "../../../assets/images/New8.jpg";
import { useNavigate } from "react-router-dom";
import Button from "../../components/Button";

const Blog2 = () => {
    const navigate = useNavigate();
  return (
    <div className="about-us-page">
      <Hero title="Blogs" backgroundImage={HeroImage} />
      <div className="primary-background-container-content">
        <div className="privacy-container">
          <h3>
            Navigating the £100,000 Childcare Cap: What NHS Consultants Need to
            Know
          </h3>
          <p>
            When working with NHS hospital consultants who are also raising
            young families, one of the most frequent concerns I hear relates to
            the £100,000 adjusted net income threshold for funded childcare.
            Crossing this line not only reduces your personal allowance but also
            results in the complete loss of up to 30 hours of funded childcare.
          </p>
          <p>
            <strong>Understanding Adjusted Net Income</strong>
          </p>
          <p>
            Adjusted net income is your total income, from all sources
            (including savings), minus allowable deductions such as pension
            contributions.
          </p>
          <p>
            For example, a newly appointed NHS consultant without on-call
            commitments, and including the August pay increment, will typically
            earn a base salary of around £109,000. Deducting NHS pension
            contributions of £5,995 brings their adjusted net income to
            £103,000.
          </p>
          <p>
            This immediately places them in the 62% marginal tax band. That’s
            because, for every £2 earned above £100,000, you lose £1 of your
            personal allowance. Between £100,000 and £125,070, this creates an
            effective additional tax charge of around £5,140 compared to
            retaining the full personal allowance.
          </p>
          <p>
            In practice, this consultant may have only lost £1,500 of their
            personal allowance (costing an additional £624 in tax), but they
            will also lose entitlement to the 30 hours of funded childcare.
          </p>
          <p>
            <strong>The Value of Funded Childcare</strong>
          </p>
          <p>
            From September 2025, all children will be entitled to 30 hours of
            funded childcare per week. Although this only applies during term
            time (38 weeks of the year), most nurseries smooth this across 51
            weeks, resulting in 22.35 funded hours per week.
          </p>
          <p>At an average childcare cost of £8 per hour, this equates to:</p>
          <p>• £178 per week saved</p>
          <p>• Around £9,000 per year in reduced childcare costs</p>
          <p>
            When combined with the Tax-Free Childcare scheme (where for every £8
            you pay in, the government adds £2, up to £2,000 per child per
            year), the overall support can make a meaningful difference. For
            many families, these benefits rank just behind mortgage or rent in
            terms of household financial impact.
          </p>
          <p>
            <strong>A Case Study</strong>
          </p>
          <p>
            Let’s consider an NHS consultant in London with additional income
            from on-call duties:
          </p>
          <p>• Adjusted net income: £111,743 (August 2025)</p>
          <p>• Additional tax from tapered personal allowance: £2,466.33</p>
          <p>• Lost 30 hours funded childcare: ~£9,000</p>
          <p>• Lost Tax-Free Childcare top-up: £2,000</p>
          <p>
            In total, exceeding £100,000 has cost this consultant over £11,000.
            Their post-tax pay rise amounted to just £5,636, meaning they are
            £5,634 worse off than if they had remained under the threshold.
          </p>
          <p>
            <strong>Options to Reduce Adjusted Net Income</strong>
          </p>
          <p>
            So, what can an NHS consultant do to remain below the £100,000
            threshold? There are several pension-related strategies worth
            exploring:
          </p>
          <p>1. Early Retirement Reduction Buy Out (ERRBO)</p>
          <p>
            Within the 2015 NHS Pension Scheme, retiring early results in a
            reduction to your pension (e.g., retiring at 65 instead of 68
            reduces it by 14%). ERRBO allows you to buy out up to three years of
            this reduction.
          </p>
          <p>
            • For a 41-year-old, this would cost around 5% additional
            contributions, or £5,587 per year
          </p>
          <p>• Contributions are fixed, offering little flexibility</p>
          <p>
            • On its own, ERRBO won’t reduce adjusted net income below £100,000
          </p>
          <p>2. Additional Pension Purchase</p>
          <p>
            It’s possible to purchase up to £8,721 of additional NHS pension per
            year at retirement.
          </p>
          <p>
            • For a 41-year-old, this requires contributions of around £7,325
            per year
          </p>
          <p>• Payments can be made monthly or annually</p>
          <p>
            • This reduces adjusted net income but, even when combined with
            ERRBO, it isn’t sufficient to bring income below £100,000
          </p>
          <p>3. Personal Pension Contributions (Most Flexible Option)</p>
          <p>A personal pension offers greater control and tax efficiency:</p>
          <p>
            • Paying in £800 per month reduces adjusted net income by £12,000
            per year (as personal contributions are grossed up at 1.25x for tax
            purposes)
          </p>
          <p>
            • This immediately brings income below £100,000, protecting
            childcare benefits.• Assuming a modest growth rate of 2.9%, this
            could build a pension pot of around £436,000 by age 65
          </p>
          <p>
            • Contributions are flexible—allowing you to increase, decrease, or
            pause payments as circumstances change.
          </p>
          <p>
            • The pot can be accessed flexibly in retirement—via a tax-free lump
            sum, income drawdown, or annuity.
          </p>
          <p>
            <strong>Final Thoughts</strong>
          </p>
          <p>
            While these strategies can help manage your adjusted net income and
            retain valuable childcare benefits, they should never be considered
            in isolation. Pension contributions, childcare support, and taxation
            are all interlinked with your wider lifestyle and retirement
            planning.
          </p>
          <p>
            A holistic financial plan—tailored to your goals and
            circumstances—ensures you make the right decisions both now and for
            your future.
          </p>
          <p>
            If you have a question about funded childcare and the 100k
            threshold, please reach out for an informal discussion about your
            circumstances.
          </p>
          <p>
            <strong>
              The value of pensions and investments and the income they produce
              can fall as well as rise. You may get back less than you invested.
            </strong>
          </p>
        </div>
        <Button
          text="CONTACT US"
          variant="primary"
          onClick={() => navigate("/contact")}
        />
      </div>
    </div>
  );
};

export default Blog2;
